export const formatDecimal = (value) => {
  const numberValue = typeof value === "string" ? parseFloat(value) : value;

  if (typeof numberValue === "number" && !isNaN(numberValue)) {
    return numberValue.toFixed(3); 
  }
  return value;
};

export const formatValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return '\u00A0'; 
    } else if (value >= 1000 && value < 1000000) {
      return `$${(value / 1000).toFixed(1)}K`;
    } else if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    } else {
      return `$${Math.floor(value).toLocaleString()}`;
    }
};

// Every timestamp on the console is rendered in UTC, on purpose.
//
// The date-range filter has always been applied in UTC calendar days: the
// backend compares `time_stamp` (stored as UTC) against `start::date` and
// `end::date + 1 day`, and the presets compute "today" as the UTC date. Until
// 2026-09-15 the timestamps themselves were rendered in the BROWSER's zone, so
// a session at 02:45 UTC on Sep 1 -- correctly inside a "Sep 1 - Sep 30" range
// -- printed as "8/31/2026, 10:45:16 PM" for an Eastern viewer and looked like
// a filter bug (found by Jason, 2026-09-15). Filter and display now speak the
// same zone, and every value carries a "UTC" suffix so nobody has to guess.
// The daily charts were already right: their labels are calendar dates from
// the backend, parsed as such (see formatDateForDisplay in the chart files).
export const DISPLAY_TIME_ZONE = "UTC";

export const formatDate = (date) => {
  if (!date) return "";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) return date; // Return original value if parsing fails
  return parsedDate.toLocaleDateString("en-US", {
    timeZone: DISPLAY_TIME_ZONE,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const formatDateTime = (date) => {
  if (!date) return "";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) return date; // Return original value if parsing fails

  // Format both date and time
  return parsedDate.toLocaleString("en-US", {
    timeZone: DISPLAY_TIME_ZONE,
    timeZoneName: "short",
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Ensures AM/PM format
  });
};

// The Sessions / Quality / Voice tabs' timestamp: "9/1/2026, 2:45:16 AM UTC".
// Empty renders as an em dash (the tabs' convention); an unparseable value is
// shown verbatim rather than as "Invalid Date". Accepts what the backend sends
// today -- Flask's RFC 1123 form, "Tue, 01 Sep 2026 02:45:16 GMT" -- as well as
// ISO strings and Date objects.
export const formatUtcDateTime = (value, empty = "\u2014") => {
  if (value === null || value === undefined || value === "") return empty;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("en-US", {
    timeZone: DISPLAY_TIME_ZONE,
    timeZoneName: "short",
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
